import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface BloodBankParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface BloodBank {
    id?: any;
    bbName?:string;
    bbSubtype?:string;
    bbCategory?:string;
    bbAddress1?:string;
     bbAddress2?:string;
    bbCity?:string;
    bbPincode?:string;
    bbLocation?:string;
    bbCompSepFlag?: string;
    bbStorageUnitFlag?:string;
    bbLicenseNumber?:string;
    bbReportMonth?:string;
    bbReportYear?:string;
    bbUniqueId?:string;
     bbnacoSupportFlag?:string;
    bbInchargePerson?:string;
    bbLicenceValidDate?:Date;
    createdDate?:Date;
     updatedDate?:Date;
     createdBy?:number;
    updatedBy?: number;
    createdIP?:string;
    updatedIP?:string;
    bbDistrict?:any;
    district?:any;
    state?:any;
    bbState?:any;
    tenantId:any;
    branchId:any;
    parameters?: BloodBankParameter[];
    links?: any;
}


export abstract class BloodBankData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<BloodBank[]>;
    abstract create(url: string, data: BloodBank): Observable<BloodBank[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract update(url: string, data: BloodBank): Observable<BloodBank>;
    abstract delete(url: string): Observable<any>;
}
